import logos from './assets/logos';

export const flighSupplierIds = {
    AmadeusFlightsId: 1,
    YupsilonFlightsId: 5,
    TravelfusionFlightsId: 6,
    TravelfusionNdcFlightsId: 18,
    AmtrakId: 19,
    BritishAirwaysFlightsId: 16,
};

const expedia = {
    id: 0,
    label: 'Expedia',
    priority: 1,
    logo: logos.expedia,
    logoIcon: logos.expediaIcon,
};
const travelcube = {
    id: 1,
    label: 'Travelcube',
    priority: 2,
    logo: logos.travelcube,
    logoIcon: logos.travelcubeIcon,
};
const amadeus = {
    id: 2,
    label: 'Amadeus',
    priority: 5,
    serviceOptions: {flights: flighSupplierIds.AmadeusFlightsId},
    logo: logos.amadeus,
    logoIcon: logos.amadeusIcon,
};
const britishAirways = {
    id: 4,
    label: 'British Airways',
};
const premierInn = {
    id: 3,
    label: 'Premier Inn',
    priority: 3,
    logo: logos.premierInn,
    logoIcon: logos.premierInnIcon,
};
const travelfusion = {
    id: 4,
    label: 'Travelodge',
    priority: 4,
    logo: logos.travelodge,
    logoIcon: logos.travelodgeIcon,
};

const bookingCom = {
    id: 5,
    label: 'Booking.com',
    priority: 5,
    logo: logos.bookingCom,
    logoIcon: logos.bookingComIcon,
};

const unknown = {
    logo: logos.unknown,
    logoIcon: logos.unknownIcon,
};

export const flightSearchSuppliers = {
    britishAirways,
};

export default {
    expedia,
    travelcube,
    amadeus,
    premierInn,
    travelfusion,
    bookingCom,
    britishAirways,
    unknown,
};

export const suppliersList = [
    expedia,
    travelcube,
    amadeus,
    premierInn,
    travelfusion,
    bookingCom,
];

export const suppliersById = {
    [expedia.id]: expedia,
    [travelcube.id]: travelcube,
    [amadeus.id]: amadeus,
    [premierInn.id]: premierInn,
    [travelfusion.id]: travelfusion,
    [bookingCom.id]: bookingCom,
};



// WEBPACK FOOTER //
// ./src/app/modules/supplier/suppliers.js